import { handleAction } from 'redux-actions';
import { combineReducers } from 'redux';
import { mergeDeepRight, converge, compose, defaultTo } from 'ramda';

import { FETCH_DELTA_CONFIG_SUCCESS } from 'app/features/deltaConfig/actionTypes';
import { MAIN_SETUP } from 'app/features/deltaConfig/constants';
import { propFromPayload, pickState } from 'app/reducers/helpers';

const mainSetup = handleAction(
  FETCH_DELTA_CONFIG_SUCCESS,
  converge(mergeDeepRight, [
    pickState,
    compose(defaultTo({}), propFromPayload(MAIN_SETUP)),
  ]),
  {},
);

const deltaConfig = combineReducers({ mainSetup });

export { mainSetup };

export default deltaConfig;
